import { EpimsBaseEntityDto } from "./epim-base.dto";
export class IncidentConsequenceDto extends EpimsBaseEntityDto {
  EventTypeId: string;
  ConsequenceName: string;
  ConsequenceIconPath: string;
  SubscriptionUserId: string;  
  Version: number;
}